import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';

import IconButton from 'components/common/IconButton';
import IconPlus from 'components/icons/IconPlus';
import IconColumns from 'components/icons/IconColumns';
import Menu from 'components/common/Menu';

import { fetchReportStructures } from 'redux/modules/reportStructures';
import { fetchBusiness } from 'redux/modules/business';

import throttle from 'utils/throttle';

import ReportStructureCreateEditDialog from 'components/reports/ReportStructureCreateEditDialog';
import ReportsCreateEditStructuresItem from './ReportsCreateEditStructuresItem';

const styles = theme => ({
  iconButtonMenu: {
    margin: -4,
    position: 'relative',
    left: -8,
    verticalAlign: 'bottom',
  },
  iconButtonEdit: {
    margin: -4,
    position: 'relative',
    verticalAlign: 'bottom',
  },
  iconPlus: {
    width: 14,
    height: 14,
    color: theme.palette.primary[500],
  },
  iconColumns: {
    width: 24,
    height: 24,
    color: theme.palette.primary[500],
  },
});

class ReportsCreateEditStructures extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      limit: 10,
      offset: 0,
      editDialogOpen: false,
    };

    this.onRequest = this.onRequest.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onTemplatesButtonClick = this.onTemplatesButtonClick.bind(this);
    this.onTemplatesScrollFetchRequest = this.onTemplatesScrollFetchRequest.bind(this);
    this.onEditButtonClick = this.onEditButtonClick.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);

    this.onRequest = throttle(this.onRequest);
  }

  componentDidMount() {
    this.props.actions.fetchBusiness({
      triggerLoading: false,
    });
    this.onRequest();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.reportStructures.length === 0) {
      this.setState({ anchorEl: null });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { limit, offset } = this.state;
    const limitChanged = prevState.limit !== limit;
    const offsetChanged = prevState.offset !== offset;
    if (limitChanged || offsetChanged) {
      this.onRequest();
    }
  }

  onRequest() {
    const { actions } = this.props;
    const { offset, limit } = this.state;
    actions.fetchReportStructures({
      triggerLoading: false,
      push: true,
      limit,
      offset,
      sortBy: [{
        name: 'ID',
        sort: 'desc',
      }],
    });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onTemplatesButtonClick(event) {
    this.setState({
      anchorEl: event.currentTarget.querySelector('svg'),
    });
  }

  onTemplatesScrollFetchRequest() {
    const { reportStructures } = this.props;
    const { offset, limit } = this.state;
    if ((reportStructures.length - limit) >= offset) {
      this.setState({ offset: offset + limit });
    }
  }

  onEditButtonClick() {
    this.setState({ editDialogOpen: true });
  }

  onEditDialogClose() {
    this.setState({ editDialogOpen: false });
  }

  render() {
    const {
      reportStructures,
      business,
      onItemSelect,
      filters,
      classes,
    } = this.props;
    const { anchorEl, editDialogOpen } = this.state;
    const open = Boolean(anchorEl);
    const selectedReportStructure = filters['Report Structure ID']
      ? reportStructures.find(item => item.ID === filters['Report Structure ID'])
      : null;
    return (
      <Fragment>
        <IconButton
          className={classes.iconButtonMenu}
          onClick={this.onTemplatesButtonClick}
          disabled={reportStructures.length === 0}
          aria-label="More"
          aria-owns="reports-structures-menu"
          aria-haspopup="true"
          tooltipContent="Select Report Columns Template"
        >
          <IconPlus className={classes.iconPlus} />
        </IconButton>
        {reportStructures.length > 0 &&
          <Menu
            id="reports-structures-menu"
            anchorEl={anchorEl}
            open={open}
            onClose={this.onMenuClose}
            onScrollFrame={(event) => {
              if (event.top > 0.8) {
                this.onTemplatesScrollFetchRequest();
              }
            }}
          >
            {reportStructures.map(item => (
              <ReportsCreateEditStructuresItem
                key={item.ID}
                onClick={() => {
                  onItemSelect(item);
                  this.onMenuClose();
                }}
                {...item}
                business={business}
              />
            ))}
          </Menu>
        }
        <IconButton
          className={classes.iconButtonEdit}
          onClick={this.onEditButtonClick}
          tooltipContent={selectedReportStructure ? 'Edit Columns Template' : 'Create Columns Template'}
        >
          <IconColumns className={classes.iconColumns} />
        </IconButton>
        <ReportStructureCreateEditDialog
          open={editDialogOpen}
          form={filters['Report Structure ID'] ? `${filters['Report Structure ID']}-reportStructureEditForm` : 'reportStructureCreateForm'}
          {...selectedReportStructure ? {
            ID: selectedReportStructure.ID,
            initialValues: {
              ID: selectedReportStructure.ID,
              Name: selectedReportStructure.Name,
              Structure: selectedReportStructure.Structure,
            }
          } : {}}
          onClose={this.onEditDialogClose}
          onSubmitSuccess={(values) => {
            onItemSelect(values);
          }}
        />
      </Fragment>
    );
  }
}

ReportsCreateEditStructures.propTypes = {
  reportStructures: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })).isRequired,
  actions: PropTypes.shape({
    fetchReportStructures: PropTypes.func.isRequired,
    fetchBusiness: PropTypes.func.isRequired,
  }).isRequired,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  classes: PropTypes.shape({
    iconButtonEdit: PropTypes.string.isRequired,
    iconPlus: PropTypes.string.isRequired,
  }).isRequired,
  onItemSelect: PropTypes.func.isRequired,
};

ReportsCreateEditStructures.defaultProps = {
  business: {},
};

const mapStateToProps = store => ({
  reportStructures: store.reportStructures.data,
  business: store.business.data,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchReportStructures, fetchBusiness }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(ReportsCreateEditStructures),
);



// WEBPACK FOOTER //
// ./src/components/reports/ReportsCreateEditForm/ReportsCreateEditStructures.js